import { Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { useState } from "react";
import arrowIcon from "src/assets/images/icon_arrow_right_white.svg";
import { ProviderItems } from "src/models/StakingPool";
import { CustomRouterLink } from "./CustomRouterLink";
import { ProviderItem } from "./ProviderItem";
import { DetailsTokenModal } from "src/modals/DetailsTokenModal";
import arrow_right from "src/assets/images/Arrow_right.svg";
import arrows3 from 'src/assets/images/arrows3.svg'


export const Provider = (props: { datas: ProviderItems[], title: string, subTitle: string, moreUrl: string, target: "_blank" | "_self" | "a", nextTitle: string, nextMoreUrl: string, nextData?: ProviderItems[], hidNextMore?: Boolean }) => {

  const [data, setData] = useState<ProviderItems>();
  const [visible, setVisible] = useState<boolean>(false)

  const element = () => {
    return <Box border="1px solid #C2C2C2" padding="9px 19px" display="flex" justifyContent="flex-end" >
      <Stack direction="row">
        <Typography
          fontSize="16px"
          color="secondary"
          sx={{
            textDecoration: "none",
          }}
        >
          See more
        </Typography>

        <Box width="7px" ml="8px">
          <img src={arrowIcon} width="100%" alt="icon" />
        </Box>
      </Stack>
    </Box>
  }
  return (
    <Box p="50px 40px 74px">
      <Box display="flex" alignItems="center">
        <img src={arrow_right} style={{ width: "36px", height: "36px", marginRight: "10px" }} />
        <Typography fontSize="30px" variant="bold" color="#FFFFFF">
          {props.title}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography fontSize="16px" color="secondary" mt="15px">
          {props.subTitle}
        </Typography>
        {
          props.target == "_blank" && <a href={props.moreUrl} style={{ textDecoration: "none" }} target={props.target}>
            {element()}
          </a>
        }
        {
          props.target == "a" && <a href={props.moreUrl} style={{ textDecoration: "none" }}>
            {element()}
          </a>
        }
        {
          props.target == "_self" && <CustomRouterLink to={props.moreUrl}>
            {element()}
          </CustomRouterLink>
        }
      </Box>


      <Box
        mt="60px"
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(5, 200px)",
          rowGap: "50px",
          justifyContent: "space-between",
        }}
      >
        {props.datas.map((item) => (
          <ProviderItem
            key={item.nodeName}
            providerItem={item}
            disable={item.type == "Soon"}
            onClick={() => {
              if (item.showModal) {
                setData(item);
                setVisible(true);
              } else {
                if (item.type != "Soon") {
                  window.open(item.url)
                }
              }
            }}
          />
        ))}
      </Box>




      <Box mt="40px" display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <img src={arrows3} style={{ width: "21px", height: "23px", marginRight: "10px" }} />
          <Typography fontSize="20px" color="#FFFFFF">
            {props.nextTitle}
          </Typography>
        </Box>
        {
          props.hidNextMore ? null : <>

            {
              props.target == "_blank" && <a href={props.nextMoreUrl} style={{ textDecoration: "none" }} target={props.target}>
                {element()}
              </a>
            }
            {
              props.target == "a" && <a href={props.nextMoreUrl} style={{ textDecoration: "none" }}>
                {element()}
              </a>
            }
            {
              props.target == "_self" && <CustomRouterLink to={props.nextMoreUrl}>
                {element()}
              </CustomRouterLink>
            }
          </>
        }

      </Box>

      <Box
        mt="35px"
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(5, 200px)",
          rowGap: "50px",
          justifyContent: "space-between",
        }}
      >
        {props.nextData?.map((item) => (
          <ProviderItem
            disable={item.type == "Soon"}
            key={item.nodeName}
            providerItem={item}
            onClick={() => {
              if (item.showModal) {
                setData(item);
                setVisible(true);
              } else {
                if (item.type != "Soon") {
                  window.open(item.url)
                }
              }
            }}
          />
        ))}
      </Box>


      {data && <DetailsTokenModal item={data} visible={visible} handleClose={() => {
        setVisible(false);
      }} />}
    </Box>
  );
};
